import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Validators} from "../_common/_form/Validators/index"
import NRTTooltip from '../../components/_common/Tooltip'
import NRTButton from "../_common/_buttons/Button/index"
import NRTFormErrorMsg from "../_common/_form/FormErrorMsg/index"
import NRTVerticalStack from "../_common/_containers/VerticalStack/index"
import NRTFormStateManager from "../_common/FormStateManager"
import NRTFormInput from "../_common/FormStateManager/FormInput"
import NRTTextInput from "../_common/_form/TextInput"
import NRTFormContainer from "../_common/_form/_containers/FormContainer"

const icon = require('./information.png')

class NRTFormUserSignIn extends Component {


    formRef = React.createRef()

    state = {
        form: {}
    }

    formChanged = (form) => {
        this.setState({form})
    }


     onSubmit =async () => {

        await this.formRef.current.validate((form) => {
            if (!form.dirty || !form.valid)
                return

            this.props.onSubmit(form.values.login , form.values.password )
        })
    }


    render() {

        const props = this.props


        return (

            <NRTFormStateManager onStateChange={this.formChanged} ref={this.formRef}>

                <NRTVerticalStack>
                    <div style={{position: 'relative'}}>
                        <NRTFormInput name={'login'}
                                      label={'Login'}
                                      inputEl={NRTTextInput}
                                      validators={[
                                          Validators.required()
                                      ]}
                        />
                        <span style={{
                            position: 'absolute',
                            top: -1,
                            left: 45
                            // right:5
                        }}>
                             <NRTTooltip

                                 position={'right'}
                                 text={`Se você for cliente entre com seu CPF. Caso seja colaborador ou instrutor,
                                 use seus dados de login do sistema.`}>
                                 <img src={icon}/>
                             </NRTTooltip>
                        </span>
                    </div>

                    <NRTFormInput name={'password'}
                                  label={'Senha'}
                                  inputEl={NRTTextInput}
                                  inputProps={{
                                      type: 'password',
                                      onEnterPressed: this.onSubmit
                                  }}
                                  validators={[
                                      Validators.required()
                                  ]}

                    />

                    {
                        !!props.loginFail &&
                        <NRTFormErrorMsg>Login ou senha inválidos.</NRTFormErrorMsg>
                    }

                    <NRTButton content={'Entrar'}
                               loading={this.props.awaiting || false }
                        onClick={this.onSubmit}

                    />

                    {
                        !! this.props.goToForgotPassword &&
                        <NRTButton onClick={this.props.goToForgotPassword} secondary

                                   style={{
                                       fontSize: '.65rem'
                                   }}
                                   content={'esqueceu sua senha?'}/>
                    }


                </NRTVerticalStack>
            </NRTFormStateManager>

        )
    }
}

NRTFormUserSignIn.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    goToForgotPassword: PropTypes.func.isRequired,
    loginFail: PropTypes.bool,
    awaiting: PropTypes.bool,

}


export default NRTFormUserSignIn



// WEBPACK FOOTER //
// ./src/components/FormUserSignIn/index.js